"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.enhanceDependencyDataProcessor = void 0;
/* eslint-disable no-param-reassign -- We want to adress envelope directly, because it is a reference to data sent to AI */ var enhanceDependencyDataProcessor = function(envelope, context) {
    var _context_correlationContext, _envelope_data_baseData;
    if (envelope.data.baseType !== 'RemoteDependencyData') {
        return true;
    }
    var customProps = context === null || context === void 0 ? void 0 : (_context_correlationContext = context.correlationContext) === null || _context_correlationContext === void 0 ? void 0 : _context_correlationContext.customProperties.props;
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain -- Optional chaining is not equevalent to the check below
    if (!customProps || !(customProps.length > 0)) {
        return true;
    }
    // Transform array of key-value pairs into a flat object
    var flattenedProps = Object.fromEntries(customProps.map(function(property) {
        return [
            property.key,
            property.value
        ];
    }));
    // Add to dependency properties
    if (Object.keys(flattenedProps).length === 0) {
        return true;
    }
    envelope.data.baseData = _object_spread_props(_object_spread({}, envelope.data.baseData), {
        properties: _object_spread({}, (_envelope_data_baseData = envelope.data.baseData) === null || _envelope_data_baseData === void 0 ? void 0 : _envelope_data_baseData.properties, flattenedProps)
    });
    return true;
};
exports.enhanceDependencyDataProcessor = enhanceDependencyDataProcessor; //# sourceMappingURL=enhanceDependencyDataProcessor.js.map
